import { showCommentFileOption } from 'reactApp/appHelpers/featuresHelpers/features/showCommentFileOption';
import { type IAccessRightsOptions, EAccessRights } from 'reactApp/components/SharingNewBiz/SharingNew.types';

export const DELETE_USER: IAccessRightsOptions = {
    key: EAccessRights.DELETE_USER,
    text: 'Закрыть доступ',
};

export const UNMOUNT_USER: IAccessRightsOptions = {
    key: EAccessRights.UNMOUNT_USER,
    text: 'Отключить доступ ',
};

// TODO: когда уберем фича-флаг, сделать объектом
export const getAccessRightsOptions = () => {
    const commonOptions = {
        [EAccessRights.READ_WRITE]: {
            key: EAccessRights.READ_WRITE,
            text: 'Редактирование',
        },
        [EAccessRights.READ_ONLY]: {
            key: EAccessRights.READ_ONLY,
            text: 'Просмотр',
        },
    };

    if (showCommentFileOption) {
        return {
            [EAccessRights.COMMENT]: {
                key: EAccessRights.COMMENT,
                text: 'Комментирование',
            },
            ...commonOptions,
        };
    }

    return commonOptions;
};
